import { render } from "./UserInstallment.vue?vue&type=template&id=5f1defca&scoped=true"
import script from "./UserInstallment.vue?vue&type=script&lang=js"
export * from "./UserInstallment.vue?vue&type=script&lang=js"

import "./UserInstallment.vue?vue&type=style&index=0&id=5f1defca&scoped=true&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1defca"]])

export default __exports__